var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtrovatoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 394.15 135.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c39;}.cls-2{fill:red;}.cls-3{fill:#f93;}.cls-4{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2Otrovato logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "373.88 20.27 373.88 115.53 20.27 115.53 20.27 135.8 394.15 135.8 394.15 20.27 373.88 20.27"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 20.27,
    y: 20.27,
    width: 353.61,
    height: 95.27
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "373.88 20.27 373.88 0 0 0 0 115.53 20.27 115.53 20.27 20.27 373.88 20.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.06,83.67C67.22,83.67,71,79,71,71s-3.8-12.59-10-12.59S51,63.06,51,71s3.88,12.67,10,12.67m0,9.3c-12.83,0-21.78-8.82-21.78-22s8.95-21.9,21.78-21.9S82.84,57.92,82.84,71s-9,22-21.78,22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.19,59.29H85.28V49.9h5.91v-12h11.64v12h9v9.39h-9V78.78c0,3.61,2.11,4.09,5.57,4.09a32.48,32.48,0,0,0,4.06-.24v9.3a41.25,41.25,0,0,1-7.6.64c-9,0-13.67-2.8-13.67-11.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146,60.81a29.25,29.25,0,0,0-3.8-.24c-6.16,0-10.89,3.61-10.89,10.11V92.09H119.54V49.9h11.81v5.94c1.94-3.69,6.33-6.18,11.82-6.18a27.68,27.68,0,0,1,2.87.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.84,83.67c6.16,0,10-4.65,10-12.67s-3.8-12.59-10-12.59-10,4.65-10,12.59,3.88,12.67,10,12.67m0,9.3c-12.83,0-21.78-8.82-21.78-22S157,49.1,169.84,49.1s21.77,8.82,21.77,21.9-8.94,22-21.77,22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "208.74 92.09 192.62 49.9 204.86 49.9 214.82 78.46 224.69 49.9 236.6 49.9 220.56 92.09 208.74 92.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M263.68,72.76,255,74.45c-3.88.72-6.75,1.92-6.75,5.29,0,2.89,2.28,4.57,5.82,4.57,5,0,9.62-2.48,9.62-7.22Zm-27.09,7.62c0-8.42,7.09-11.95,16-13.47l11.05-2v-.64c0-3.61-1.94-5.86-6.83-5.86-4.39,0-6.67,1.85-7.68,5.62l-11.23-2c2-7.13,8.78-12.91,19.33-12.91,11.22,0,18,4.89,18,14.68V81c0,2.25,1,3,3.63,2.65v8.42c-7.52,1-12.07-.4-14-3.93-2.86,3-7.34,4.65-13.16,4.65-8.69,0-15.11-5-15.11-12.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M286.55,59.29h-5.91V49.9h5.91v-12H298.2v12h9v9.39h-9V78.78c0,3.61,2.11,4.09,5.57,4.09a32.32,32.32,0,0,0,4.05-.24v9.3a41.09,41.09,0,0,1-7.6.64c-8.94,0-13.67-2.8-13.67-11.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M333.73,83.67c6.16,0,10-4.65,10-12.67s-3.8-12.59-10-12.59S323.68,63.06,323.68,71s3.89,12.67,10.05,12.67m0,9.3C320.9,93,312,84.15,312,71s8.95-21.9,21.78-21.9S355.5,57.92,355.5,71s-8.94,22-21.77,22"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtrovatoLogo);
export default __webpack_public_path__ + "static/media/Otrovato-Logo.79526705f5f3dd998a44221a79548795.svg";
export { ForwardRef as ReactComponent };